var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"videoWrapper relative h-0 mb-6"},[_c('iframe',{staticClass:"absolute h-full w-full top-0 left-0",attrs:{"src":_vm.embedSrc,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }